import { styled as o, css as i } from "styled-components";
import { Box as a, flexModifiers as t } from "../Flexbox/Flexbox.mjs";
const f = /* @__PURE__ */ o(a).withConfig({
  shouldForwardProp: (r) => ![
    "variant"
  ].includes(r)
}).withConfig({
  componentId: "sc-5cd37afc-0"
})([
  "",
  " ",
  ""
], ({ theme: { components: r }, variant: d }) => /* @__PURE__ */ i([
  "",
  " ",
  ""
], r.card.base, d ? r.card[d] : r.card.light), t);
export {
  f as default
};
